const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/home': 'Dashboard',
  '/configuracao/config-balanca': 'Configurar Balanças',
  '/configuracao/varejo': 'Cadastrar códigos para relatório Varejo',
  '/configuracao/modelos-etiqueta': 'Modelos de Etiqueta',
  '/configuracao/modelos-etiqueta/form': 'Novo Modelo de Etiqueta',
  '/configuracao/impressoras': 'Impressoras',
  '/configuracao/integracoes': 'Integrações',
  '/configuracao/produtos': 'Produtos',
  '/configuracao/catalogo-produto': 'Parâmetros do Catálogo',
  '/configuracao/modelos-barcode': 'Modelos de Código de Barras',
  '/configuracao/estoque-fisico': 'Estoque Físico',
  '/relatorio/historicos-integracao': 'Histórico de Integrações',
  '/estoque/relatorio-estoque': 'Estoque Geral',
  '/estoque/visualizacao-estoque': 'Visualização de Estoque - Fresco Indústria',
  '/estoque/controle-estoque': 'Controle de Estoque Fresco',
  '/movimentacao/entrada-produto': 'Entrada de Produtos',
  '/movimentacao/leitura-pedido': 'Leitura de Pedidos',
  '/movimentacao/conferencia-xml': 'Conferência XML',
  '/movimentacao/enderecamento': 'Endereçamento',
  '/movimentacao/coleta-pesos': 'Coleta de Pesos',
  '/consulta/etiquetas': 'Consulta de Etiquetas',
  '/relatorio/etiquetas': 'Relatório de Etiquetas',
  '/relatorio/curva-abc': 'Relatório Curva ABC',
  '/relatorio/giro-estoque': 'Relatório Giro Estoque',
  '/relatorio/mapa-producao-expedicao': 'Mapa Produção / Expedição',
};

export const APP_TITLE = 'WMS Lite';

function normalizePath(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

function humanizeSegment(segment: string): string {
  return segment
    .replace(/^\$/, '')
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function humanizePath(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) {
    return 'Dashboard';
  }

  const last = segments[segments.length - 1];

  if (last === 'form') {
    const parent = segments[segments.length - 2];
    return parent ? `${humanizeSegment(parent)} - Formulário` : 'Formulário';
  }

  if (/^\d+$/.test(last) || last.startsWith('$') || /^[0-9a-f-]{36}$/i.test(last)) {
    const parent = segments[segments.length - 2];
    if (parent === 'form') {
      const grandparent = segments[segments.length - 3];
      return grandparent
        ? `Editar ${humanizeSegment(grandparent)}`
        : 'Editar';
    }
    return parent ? `${humanizeSegment(parent)} - Detalhes` : 'Detalhes';
  }

  return humanizeSegment(last);
}

export function getPageTitle(pathname: string): string {
  const path = normalizePath(pathname);

  if (PAGE_TITLES[path]) {
    return PAGE_TITLES[path];
  }

  const segments = path.split('/').filter(Boolean);
  const last = segments[segments.length - 1];
  const isDynamicId = /^\d+$/.test(last) || /^[0-9a-f-]{36}$/i.test(last);

  if (isDynamicId) {
    return humanizePath(path);
  }

  const sortedPaths = Object.keys(PAGE_TITLES).sort((a, b) => b.length - a.length);

  for (const knownPath of sortedPaths) {
    if (path === knownPath || path.startsWith(`${knownPath}/`)) {
      return PAGE_TITLES[knownPath];
    }
  }

  return humanizePath(path);
}

export function getDocumentTitle(pathname: string): string {
  return `${getPageTitle(pathname)} | ${APP_TITLE}`;
}
